import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import iNomCateg from '@/types/iNomCateg';
import iNomTipDoc from '@/types/iNomTipDoc';
import nomenclatoare from '@/store/nomenclatoare';
import {getModule} from 'vuex-module-decorators';
//const EditNomCateg = () => import('@/components/EditNomCateg/EditNomCateg.vue').then(m => m.default)

interface iNomTipDocWithDenCateg extends iNomTipDoc{
  den_categ:string
}

// @ts-ignore
@Component({components: {}
})
export default class Search extends Vue {
  public filter: string = '';
  public appidTipDoc: number = 0;
  public loadingData: boolean = false;
  public visibleDialogEditTipDoc: boolean = false;
  public myPagination:any={
    rowsPerPage:10
  }
  public visibleColumns: string[] = [ 'id_tip_doc', 'den_lang_1', 'den_lang_2', 'den_categ'];
  public  columns: any = [
    { name: 'appid', label: 'appid', field: 'appid' },
    { name: 'id_tip_doc', label: 'Id', field: 'id_tip_doc', align: 'left', sortable: true },
    { name: 'den_lang_1', label: 'Denumnire romana', field: 'den_lang_1', sortable: true, align: 'left' },
    { name: 'den_lang_2', label: 'Denumire maghiara', field: 'den_lang_2', sortable: true, align: 'left' },
    { name: 'den_categ', label: 'Categorie', field: 'den_categ', sortable: true, align: 'left' }
  ];
  public tableDataNomCateg: iNomCateg[] = [];
  public tableDataNomTipDoc: iNomTipDocWithDenCateg[] = [];
  public $refs: any;
  private storeNomenclatoare = getModule(nomenclatoare);
  // private userStore=getModule(User);

  constructor() {
    super();
  }

  public addRow() {
    this.appidTipDoc = 0;
    this.visibleDialogEditTipDoc = true;
  }
  public goToView(pRouteViewName: string ) {
    this.$router.push({ name: pRouteViewName })
  }
  public renuntEditareTipDoc() {
    this.visibleDialogEditTipDoc = false;
  }


  public created() {
    const vueInst = this;
  }
}
